"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartBeat = void 0;
var tslib_1 = require("tslib");
var events_1 = require("events");
var time_1 = require("@walletconnect/time");
var types_1 = require("./types");
var constants_1 = require("./constants");
var HeartBeat = /*#__PURE__*/function (_types_1$IHeartBeat) {
  _inherits(HeartBeat, _types_1$IHeartBeat);
  var _super = _createSuper(HeartBeat);
  function HeartBeat(opts) {
    var _this;
    _classCallCheck(this, HeartBeat);
    _this = _super.call(this, opts);
    _this.events = new events_1.EventEmitter();
    _this.interval = constants_1.HEARTBEAT_INTERVAL;
    _this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || constants_1.HEARTBEAT_INTERVAL;
    return _this;
  }
  _createClass(HeartBeat, [{
    key: "init",
    value: function init() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.initialize();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.intervalRef);
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.intervalRef = setInterval(function () {
                return _this2.pulse();
              }, time_1.toMiliseconds(this.interval));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "pulse",
    value: function pulse() {
      this.events.emit(constants_1.HEARTBEAT_EVENTS.pulse);
    }
  }], [{
    key: "init",
    value: function init(opts) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var heartbeat;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              heartbeat = new HeartBeat(opts);
              _context3.next = 3;
              return heartbeat.init();
            case 3:
              return _context3.abrupt("return", heartbeat);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
  }]);
  return HeartBeat;
}(types_1.IHeartBeat);
exports.HeartBeat = HeartBeat;